export type PromotionItem = {
  id: number
  title: string
  caption: string
  image: string
  href: string
}

const ZALO_MINI_APP_PROMOTION_URL =
  "https://zalo.me/s/327411629127312067/games/affiliate-massoffer"

export const FEATURED_PROMOTION: PromotionItem = {
  id: 0,
  title: "Ưu đãi tháng 04/2026",
  caption: "Kho voucher TuTiMi cập nhật liên tục mỗi tuần trên Zalo Mini App",
  image: "/web-ttmi/homepage/TTMI-COVER-WEB-MILO.jpg",
  href: ZALO_MINI_APP_PROMOTION_URL,
}

export const PROMOTION_ITEMS: PromotionItem[] = [
  {
    id: 1,
    title: "Giảm 30K cho hóa đơn từ 129K",
    caption: "Có sẵn - click lấy ngay miễn phí",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 2,
    title: "Giảm 40K cho hóa đơn từ 169K",
    caption: "Có sẵn - click lấy ngay miễn phí",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 3,
    title: "Mua 2 tặng 1",
    caption: "Có sẵn - click lấy ngay miễn phí",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 4,
    title: "Mua 3 tặng 1",
    caption: "Có sẵn - click lấy ngay miễn phí",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 5,
    title: "Tặng topping cho đơn từ 79K",
    caption: "Có sẵn - số lượng có hạn",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 6,
    title: "Tặng 1 bánh cho hóa đơn lớn",
    caption: "Có sẵn - số lượng có hạn",
    image: "/products/TRA-SUA-THAP-CAM-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 7,
    title: "Deal thành viên mới",
    caption: "Có sẵn - click lấy ngay miễn phí",
    image: "/products/TRA-SUA-THAI-XANH-scaled.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
  {
    id: 8,
    title: "Ưu đãi nhóm cuối tuần",
    caption: "Có sẵn - số lượng có hạn",
    image: "/products/MILO-DAM-THAP-CAM-TUTIMI-600x600.jpg",
    href: ZALO_MINI_APP_PROMOTION_URL,
  },
]

export const MINI_APP_STEPS = [
  "Mở Zalo trên điện thoại và vào Mini App của TuTiMi.",
  "Chọn voucher phù hợp rồi nhấn lưu vào kho ưu đãi.",
  "Đưa mã cho nhân viên quét khi thanh toán tại cửa hàng.",
] as const



export const PROMOTION_GUIDE_STEPS = [
  "B1. Bấm vào ảnh mã giảm giá TuTiMi muốn lấy.",
  "B2. Lướt chọn và bấm “Nhận Ưu Đãi Ngay”.",
  "B3. Chụp màn hình voucher hoặc mở trực tiếp trên Zalo Mini App.",
  "B4. Mang mã ưu đãi đến cửa hàng và áp dụng.",
] as const

export type PromotionBlogItem = {
  id: number
  title: string
  excerpt: string
  day: string
  month: string
  image: string
}

export const PROMOTION_BLOG_ITEMS: PromotionBlogItem[] = [
  {
    id: 1,
    title: "Mã Giảm Giá TuTiMi Đầy Đủ Nhất 04/2026",
    excerpt:
      "Tổng hợp các mã ưu đãi TuTiMi mới nhất, dễ dùng tại cửa hàng và phù hợp cho cả khách lẻ lẫn nhóm bạn.",
    day: "15",
    month: "Th4",
    image: "/products/TRA-SUA-THAI-XANH-scaled.jpg",
  },
  {
    id: 2,
    title: "Voucher Milo Dầm TuTiMi Mới Nhất",
    excerpt:
      "Khám phá các ưu đãi áp dụng cho dòng Milo Dầm, topping đi kèm và chương trình mua nhóm tiết kiệm hơn.",
    day: "12",
    month: "Th4",
    image: "/products/MILO-DAM-THAP-CAM-TUTIMI-600x600.jpg",
  },
  {
    id: 3,
    title: "Voucher Trà Sữa TuTiMi Cho Nhóm Bạn",
    excerpt:
      "Danh sách deal mua 2 tặng 1, mua 3 tặng 1 cùng hướng dẫn lưu voucher nhanh trên Zalo Mini App.",
    day: "08",
    month: "Th4",
    image: "/products/TRA-SUA-TRUYEN-THONG-scaled.jpg",
  },
]

export type PromotionCommunityItem = {
  id: number
  title: string
  description: string
  ctaLabel: string
  href: string
}

export const PROMOTION_COMMUNITY_ITEMS: PromotionCommunityItem[] = [
  {
    id: 1,
    title: "GROUP FACEBOOK",
    description:
      "Mời bạn tham gia nhóm để nhận chương trình giảm giá TuTiMi nhanh nhất.",
    ctaLabel: "Tham Gia Ngay",
    href: "https://www.facebook.com/trasuatutimi",
  },
  {
    id: 2,
    title: "FANPAGE FACEBOOK",
    description:
      "Theo dõi fanpage để cập nhật voucher mới, menu mới và các chương trình theo mùa.",
    ctaLabel: "Tham Gia Ngay",
    href: "https://www.facebook.com/trasuatutimi",
  },
  {
    id: 3,
    title: "GROUP ZALO",
    description:
      "Mời bạn tham gia nhóm để nhận chương trình giảm giá TuTiMi nhanh nhất.",
    ctaLabel: "Tham Gia Ngay",
    href: "https://zalo.me",
  },
]
